import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  globalStyle,
  handleDangerVisible,
  handleVisible,
} from "../../global/Utils";
import { getUserList, getCompanyWithUser } from "../../Actions/UserAction";
import {
  addFbrSnroTesting,
  getFbrSnroTesting,
} from "../../Actions/FBRSnroTestingAction";
import { Box, CircularProgress } from "@mui/material";
import { SearchableSelect } from "../Common/SearchableSelect";

const UserScenerioTesting = () => {
  const dispatch = useDispatch();

  const { isAddingFbrSnroTesting, fbrSnroListList, isGettingFbrSnroTesting } =
    useSelector((state) => state.FBRSnroTestingReducer);
  const {
    userList,
    isGettingUserList,
    isGettingCompanyForUser,
    companiesList,
  } = useSelector((state) => state.UserReducer);
  const [companyId, setCompanyId] = useState("");
  const [userId, setUserId] = useState("");
  const [showCards, setShowCards] = useState(false);
  const [errors, setErrors] = useState({});
  const [verifyingId, setVerifyingId] = useState(null);

  /* ------------------ SUBMIT ------------------ */
  const handleSubmit = (id) => {
    if (!id) return;
    setVerifyingId(id);
    dispatch(
      addFbrSnroTesting(
        {
          companyId: companyId,
          scenarioId: id,
        },
        handleVisible,
        handleDangerVisible,
      ),
    );
  };

  const handleValidation = () => {
    let tempErrors = {};
    if (!companyId) tempErrors.companyId = "Company is required";
    if (!userId) tempErrors.userId = "User is required";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSearchFbrScenerio = (e) => {
    e.preventDefault();
    if (!handleValidation()) return;
    if (!userId) return setErrors({ userId: "User is required" });
    dispatch(getFbrSnroTesting(companyId));
    setShowCards(true);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(getUserList("", "", "", ""));
    }, 500);
    return () => clearTimeout(timer);
  }, [dispatch]);

  return (
    <>
      {isGettingUserList ? (
        <Box
          sx={{
            position: "fixed", // ✅ covers full screen
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255,255,255,0.6)", // optional overlay
            zIndex: 9999,
          }}
        >
          <CircularProgress size={40} />
        </Box>
      ) : (
        <div className="w-full min-h-fit flex flex-col items-center py-4">
          <form className="w-full space-y-6">
            <h2
              className="text-center font-bold text-xl"
              style={{
                fontFamily: globalStyle.fontFamilyHeading,
                color: globalStyle.curveDarkColor,
              }}
            >
              Admin Scenerio Testing
            </h2>
            {/* GRID */}
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
              {/* User Name */}
              <div>
                <label className="block mb-1 font-medium">
                  User Name<span className="text-red-500">*</span>
                </label>
                <SearchableSelect
                  name="userId"
                  value={userId}
                  onChange={(e) => {
                    setUserId(e.target.value);
                    if (e.target.value) {
                      setErrors({ ...errors, userId: "" });
                      dispatch(getCompanyWithUser(e.target.value));
                    }
                    setCompanyId("");
                    setShowCards(false);
                  }}
                  disabled={!userList || userList.length === 0}
                  className={`w-full px-4 py-2 border rounded-md ${
                    errors.userId ? "border-red-500" : "border-gray-300"
                  }`}
                >
                  {!userList || userList.length === 0 ? (
                    <option value="">No Users Available</option>
                  ) : (
                    <>
                      <option value="">Select</option>
                      {userList.map((user) => (
                        <option key={user._id} value={user._id}>
                          {user.email}
                        </option>
                      ))}
                    </>
                  )}
                </SearchableSelect>
                {errors.userId && (
                  <p className="text-red-500 text-sm mt-1">{errors.userId}</p>
                )}
              </div>
              {/* Company Name */}
              {isGettingCompanyForUser ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "80px",
                  }}
                >
                  <CircularProgress size={30} />
                </Box>
              ) : (
                <div>
                  <label className="block mb-1 font-medium">
                    Company Name<span className="text-red-500">*</span>
                  </label>
                  <SearchableSelect
                    name="companyId"
                    value={companyId}
                    onChange={(e) => {
                      setCompanyId(e.target.value);
                      if (e.target.value) {
                        setErrors({ ...errors, companyId: "" });
                      }
                    }}
                    disabled={!companiesList || companiesList.length === 0}
                    className={`uppercase w-full px-4 py-2 border rounded-md ${
                      errors.companyId ? "border-red-500" : "border-gray-300"
                    }`}
                  >
                    {!companiesList || companiesList.length === 0 ? (
                      <option value="">No Companies Available</option>
                    ) : (
                      <>
                        <option value="">Select</option>
                        {companiesList.map((company) => (
                          <option key={company._id} value={company._id}>
                            {company.companyName} / {company?.ntn}
                          </option>
                        ))}
                      </>
                    )}
                  </SearchableSelect>
                  {errors.companyId && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.companyId}
                    </p>
                  )}
                </div>
              )}
            </div>
            {/* SUBMIT */}
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
              <button
                type="button"
                disabled={isGettingFbrSnroTesting}
                onClick={(e) => {
                  handleSearchFbrScenerio(e);
                }}
                className="w-full md:w-[40%] mx-auto block py-2 rounded-md text-white font-bold disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-400"
                style={{ background: globalStyle.buttonColor }}
              >
                {isGettingFbrSnroTesting
                  ? "Please Wait..."
                  : "Get Company Scenerio for FBR"}
              </button>
            </div>
          </form>
          {showCards && !isGettingFbrSnroTesting && fbrSnroListList?.length > 0 && (
            <div className="w-full mt-6 grid grid-cols-3 gap-4">
              {[
                {
                  label: "Total",
                  count: fbrSnroListList.length,
                  bg: "bg-blue-50",
                  border: "border-blue-200",
                  text: "text-blue-700",
                },
                {
                  label: "Verified",
                  count: fbrSnroListList.filter((i) => i.status === "Verified").length,
                  bg: "bg-green-50",
                  border: "border-green-200",
                  text: "text-green-700",
                },
                {
                  label: "Pending",
                  count: fbrSnroListList.filter((i) => i.status !== "Verified").length,
                  bg: "bg-orange-50",
                  border: "border-orange-200",
                  text: "text-orange-700",
                },
              ].map(({ label, count, bg, border, text }) => (
                <div
                  key={label}
                  className={`rounded-xl border ${bg} ${border} shadow-sm p-4 flex flex-col items-center justify-center`}
                >
                  <span className={`text-3xl font-bold ${text}`}>{count}</span>
                  <span className={`text-sm font-medium mt-1 ${text}`}>{label}</span>
                </div>
              ))}
            </div>
          )}
          {showCards && (
            <div className="w-full mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {isGettingFbrSnroTesting ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "80px",
                  }}
                >
                  <CircularProgress size={50} />
                </Box>
              ) : (
                [...fbrSnroListList]
                  .sort(
                    (a, b) =>
                      Number(a.status === "Verified") -
                      Number(b.status === "Verified"),
                  )
                  ?.map((item) => {
                    const isVerified = item.status === "Verified";
                    const isThisVerifying = verifyingId === item._id;
                    return (
                      <div
                        key={item._id}
                        className="border rounded-xl shadow-md p-4 bg-white flex flex-col justify-between"
                      >
                        {/* Top Row */}
                        <div className="flex justify-between items-center mb-2">
                          <span
                            className={`text-xs px-2 py-1 rounded-full font-semibold ${
                              item.status === "Verified"
                                ? "bg-green-100 text-green-700"
                                : "bg-orange-100 text-orange-700"
                            }`}
                          >
                            {item.status}
                          </span>
                          <span className="text-xs font-medium text-gray-500">
                            {item.scenarioCode}
                          </span>
                        </div>
                        {/* Name */}
                        <div className="flex-1 flex items-center justify-center text-center py-4">
                          <h3 className="font-semibold text-sm">{item.name}</h3>
                        </div>
                        {/* Verification Count */}
                        <div className="flex items-center justify-center mb-2">
                          <span className="text-xs text-gray-500 mr-1">Verified Count:</span>
                          <span className={`text-sm font-bold ${item.verificationCount > 0 ? "text-green-600" : "text-gray-400"}`}>
                            {item.verificationCount ?? 0}
                          </span>
                        </div>
                        {/* Button */}
                        <div className="mt-3">
                          {isVerified ? (
                            // <div className="text-center text-green-600 font-medium text-sm">
                            //   {item.status}
                            // </div>
                            <button
                              className="w-full py-2 rounded-lg text-white text-sm font-semibold bg-purple-600 hover:bg-purple-700 disabled:bg-gray-600 disabled:cursor-not-allowed"
                              onClick={() => handleSubmit(item._id)}
                              disabled={isAddingFbrSnroTesting}
                            >
                              {isAddingFbrSnroTesting
                                ? isThisVerifying
                                  ? "Re-Verifying..."
                                  : "Please Wait..."
                                : "Re-Verify"}
                            </button>
                          ) : (
                            <button
                              className="w-full py-2 rounded-lg text-white text-sm font-semibold bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 disabled:cursor-not-allowed"
                              onClick={() => handleSubmit(item._id)}
                              disabled={isAddingFbrSnroTesting}
                            >
                              {isAddingFbrSnroTesting
                                ? isThisVerifying
                                  ? "Verifying..."
                                  : "Please Wait..."
                                : "Verify"}
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default UserScenerioTesting;
